import { cn } from '@shared/cove-ui';
import { LayoutVariant } from '../Layout';
import DesktopFooter from './desktopFooter';
import { links } from './links';
import MobileFooter from './mobileFooter';

const Footer: React.FC<{
  onSubscribe: (email: string) => Promise<{ status: string }>;
  isMinimal?: boolean;
  variant?: LayoutVariant;
}> = ({ onSubscribe, isMinimal, variant = 'base', ...props }) => {
  return (
    <footer
      className={cn(
        'flex w-full',
        variant === 'activate' ? 'bg-cove-navy-blue' : 'bg-cove-dove'
      )}
    >
      <DesktopFooter
        key="desktop-footer"
        links={links}
        onSubscribe={onSubscribe}
        isMinimal={isMinimal}
        variant={variant}
        {...props}
      />
      <MobileFooter
        key="mobile-footer"
        links={links}
        onSubscribe={onSubscribe}
        isMinimal={isMinimal}
        variant={variant}
        {...props}
      />
    </footer>
  );
};

export default Footer;
